(() => {
  "use strict";

  document.querySelectorAll(".mobile-menu-panel a").forEach((link) => {
    link.addEventListener("click", () => {
      const menu = link.closest("details");
      if (menu) menu.open = false;
    });
  });

  document.querySelectorAll("[data-demo-form]").forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const message = form.querySelector("[data-form-message]");
      if (message) message.hidden = false;
    });
  });

  const packOptions = document.querySelectorAll("[data-pack-option]");
  const packButton = document.querySelector("[data-pack-button]");
  packOptions.forEach((option) => {
    option.addEventListener("change", () => {
      if (packButton && option.checked) {
        packButton.querySelector("span:first-child").textContent = option.dataset.buttonText || "Choose your pack";
      }
    });
  });

  const purchaseOptions = document.querySelectorAll("[data-purchase-option]");
  const landingPrice = document.querySelector("[data-landing-price]");
  purchaseOptions.forEach((option) => {
    option.addEventListener("change", () => {
      if (landingPrice && option.checked) landingPrice.textContent = option.dataset.price || "";
    });
  });
})();
